import React from "react";
import DateInputWithIcon from "pages/transaksi/booking-v3/components/DateInputWithIcon";

const AccountingHeaderFilter = ({
  filterOptions,
  handleSearch,
  updateFilter,
  allPaymentMethods,
}) => {
  return (
    <>
      {/* Header */}
      <div className="d-flex align-items-center gap-3">
        <h3 className="mb-0">ACCOUNTING</h3>
      </div>

      {/* Filters Row */}
      <div className="row mb-4">
        {/* 🔹 Search Input */}
                <div className="col-md-2 col-sm-6">

          <label className="form-label text-muted small mb-1">Search</label>
          <input
            type="text"
            className="form-control"
            placeholder="Cari Nama Tamu, Hotel, atau Agent..."
            defaultValue={filterOptions.search}
            onChange={handleSearch}
          />
        </div>

        <div className="col-md-2 col-sm-6">
          <label className="form-label text-muted small mb-1">Start Date</label>
          <DateInputWithIcon
            value={filterOptions.filters.start_date}
            onChange={(date) => updateFilter("start_date", date)}
          />
        </div>
        <div className="col-md-2 col-sm-6">
          <label className="form-label text-muted small mb-1">End Date</label>
          <DateInputWithIcon
            value={filterOptions.filters.end_date}
            onChange={(date) => updateFilter("end_date", date)}
          />
        </div>

        <div className="col-md-3 mb-2">
          <label className="form-label text-muted small mb-1">Payment Method</label>
          <select
            className="form-select"
            value={filterOptions.filters.payment_method_id}
            onChange={(e) => updateFilter("payment_method_id", e.target.value)}
          >
            <option value="">All Payment Methods</option>
            {allPaymentMethods?.map((method) => (
              <option key={method.id} value={method.id}>
                {method.name}
              </option>
            ))}
          </select>
        </div>
        <div className="col-md-3 mb-2">
          <label className="form-label text-muted small mb-1">Type</label>
          <select
            className="form-select"
            value={filterOptions.filters.type}
            onChange={(e) => updateFilter("type", e.target.value)}
          >
            <option value="">All Types (NAM, MM, BM, JOSH, dll)</option>
            <option value="nam">NAM</option>
            <option value="mm">MM</option>
            <option value="bm">BM</option>
            <option value="josh">JOSH / J</option>
            <option value="pj">PJ</option>
          </select>
        </div>
        <div className="col-md-3 mb-2">
          <label className="form-label text-muted small mb-1">Status</label>
          <select
            className="form-select"
            value={filterOptions.filters.status}
            onChange={(e) => updateFilter("status", e.target.value)}
          >
            <option value="finished">Finished</option>
            <option value="played">Played</option>
            <option value="finished,played">Finished & Played</option>
            <option value="">All Statuses</option>
          </select>
        </div>
      </div>
    </>
  );
};

export default AccountingHeaderFilter;
